import { Injectable } from '@angular/core';
import { BROWSER } from './browser.config';
declare global {
  interface Window {
    chrome?: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  userAgent = window.navigator.userAgent;
  constructor() {}

  getBrowserName(): string {
    var browserName = (function (agent) {
      switch (true) {
        case agent.indexOf('edge') > -1 || agent.indexOf('edg/') > -1:
          return BROWSER.EDGE;
        case agent.indexOf('chrome') > -1 && !!window.chrome:
          return BROWSER.CHROME;
        case agent.indexOf('firefox') > -1:
          return BROWSER.FIREFOX;
        case agent.indexOf('safari') > -1:
          return BROWSER.SAFARI;
        default:
          return BROWSER.CHROME;
      }
    })(this.userAgent.toLowerCase());
    return browserName;
  }
}
